import useUrl from '../helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('profile')
  return {
    /** @returns {Promise<AxiosResponse<ProfileInfoResponse>>} */
    profileInfo({ affise } = {}) {
      const url = root('info')
      const params = affise ? { affise } : {}
      return client.get(url, { params })
    },

    /** @returns {Promise<AxiosResponse<ProfileInfoBonusesResponse>>} */
    profileInfoBonuses() {
      const url = root('info/bonuses')
      return client.get(url)
    },

    /** @param {Object} ProfileUpdateDTO
      * @param {string} ProfileUpdateDTO.name
      * @returns {Promise<AxiosResponse<ProfileUpdateResponse>>} */
    profileUpdate({ name }) {
      const url = root('update')
      return client.put(url, { name })
    },

    // WARN: Usages not found
    profileSave(data) {
      const url = root('save')
      return client.put(url, data)
    },

    /** @param {Object} VerifyINNDTO
      * @param {string} VerifyINNDTO.inn
      * @returns {Promise<AxiosResponse<StatusTrueResponse>>} */
    verifyInn({ inn }) {
      const url = root('inn')
      return client.post(url, { inn })
    },
  }
}
